import axios from 'axios';
import { getI18n } from 'react-i18next';
import { showErrorNotification } from './notifications';
import Constants from '../utils/Constants';

export const onLoadEnvConfigurationResponse = (dispatch) => (response) => {
    const currentConfiguration = {};
    response.data.propertySources.forEach((propertySource) => {
        const propertyKeys = Object.keys(propertySource.properties);
        propertyKeys.forEach((propertyKey) => {
            if (!Object.prototype.hasOwnProperty.call(currentConfiguration, propertyKey)) {
                currentConfiguration[propertyKey] = propertySource.properties[propertyKey].value;
            }
        });
    });
    dispatch(envConfigurationLoaded(currentConfiguration));
};

export const onLoadEnvConfigurationError = (dispatch) => (error) => {
    const i18n = getI18n();
    const { response } = error;
    if (response) {
        dispatch(showErrorNotification(i18n.t('settings.env-configuration.load-failed', { message: response.statusText })));
    } else {
        dispatch(showErrorNotification(i18n.t('settings.env-configuration.load-failed', { message: error.message })));
    }
};

export const loadEnvConfiguration = (accessToken) => (dispatch) => {
    axios.get(Constants.ENV_PATH, {
        headers: {
            Authorization: `${Constants.BEARER_PREFIX} ${accessToken}`,
        },
    })
        .then(onLoadEnvConfigurationResponse(dispatch))
        .catch(onLoadEnvConfigurationError(dispatch));
};

export const ENV_CONFIGURATION_LOADED = 'ENV_CONFIGURATION_LOADED';
export const envConfigurationLoaded = (configuration) => ({
    type: ENV_CONFIGURATION_LOADED,
    payload: configuration,
});
